import { appIntegration } from '@app/utils/integration';
import type { IAccountServiceUser } from '@inter-ikea-kompis/services';
import { AccountService } from '@inter-ikea-kompis/services';
import { isIkeaApp } from '@inter-ikea-storageone/shared/utils/platform';

type GetUserParams = Parameters<InstanceType<typeof AccountService>['getUser']>;

export class PlannerAccountService extends AccountService {
  async getUser(...params: GetUserParams): Promise<IAccountServiceUser | null> {
    if (isIkeaApp()) {
      const token = appIntegration!.getMessage()?.accessToken;

      if (!token) return null;

      return {
        // Name should not be visible in the IKEA App context
        displayName: 'IKEA App User',
        initials: 'IAU',
        accessToken: token
      };
    }

    return await super.getUser(...params);
  }
}
